import _styled from "@emotion/styled-base";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from "react";
import { css } from "@emotion/core";
var DEFAULT_SIZE = "3rem";

function toPxIfNumber(value) {
  if (value == null) return DEFAULT_SIZE; // eslint-disable-next-line no-restricted-globals

  if (isNaN(value)) {
    return value;
  }

  return value + "px";
}

var Image = _styled("img", {
  target: "ekf0kt70"
})(function (_ref) {
  var theme = _ref.theme;
  return (
    /*#__PURE__*/
    css("width:100%;height:100%;border-radius:100%;overflow:hidden;font-size:", theme.fontSizes.xs, ";border:1px solid ", theme.colors.white, ";")
  );
});

var LetterDisplay =
/*#__PURE__*/
_styled("abbr", {
  target: "ekf0kt71"
})(function (_ref2) {
  var visualMode = _ref2.visualMode,
      theme = _ref2.theme;
  return (
    /*#__PURE__*/
    css("font-size:0.6em;font-family:", theme.fonts.heading, ";color:", visualMode === "light" ? theme.colors.blue : theme.colors.white, ";border-bottom:none !important;cursor:inherit !important;text-decoration:none !important;position:relative;top:0.1em;")
  );
});

var Container = _styled("div", {
  target: "ekf0kt72"
})(function (_ref3) {
  var size = _ref3.size,
      theme = _ref3.theme;
  return (
    /*#__PURE__*/
    css("width:", toPxIfNumber(size), ";height:", toPxIfNumber(size), ";font-size:", toPxIfNumber(size), ";border-radius:100%;border:1px solid ", theme.colors.blues[700], ";background-color:", theme.colors.blues[700], ";display:flex;justify-content:center;align-items:center;")
  );
}, function (_ref4) {
  var visualMode = _ref4.visualMode,
      theme = _ref4.theme;
  return visualMode === "light" &&
  /*#__PURE__*/
  css("border:1px solid ", theme.colors.blues[200], ";background-color:white;");
});

var Avatar =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Avatar, _Component);

  function Avatar() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Avatar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        imageSrc = _this$props.imageSrc,
        display = _this$props.display,
        visualMode = _this$props.visualMode,
        size = _this$props.size,
        props = _objectWithoutPropertiesLoose(_this$props, ["imageSrc", "display", "visualMode", "size"]);

    return ___EmotionJSX(Container, _extends({
      size: size,
      visualMode: visualMode
    }, props), imageSrc != null ? ___EmotionJSX(Image, {
      src: imageSrc,
      visualMode: visualMode,
      alt: display
    }) : ___EmotionJSX(LetterDisplay, {
      title: display,
      visualMode: visualMode
    }, imageSrc == null && display != null && display.length > 0 && display.charAt(0).toUpperCase()));
  };

  return Avatar;
}(Component);

_defineProperty(Avatar, "defaultProps", {
  imageSrc: undefined,
  display: undefined,
  visualMode: "light",
  size: DEFAULT_SIZE
});

export default Avatar;